module.exports = __webpack_public_path__ + "img/banner.e51b8b0b.jpg";